import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL      = import.meta.env.VITE_SUPABASE_URL      || "https://mkfmlsgxiafbyehftxol.supabase.co";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "sb_publishable_QcKeNDbD_GVZbqOlNxzDnw_9vAHv1EZ";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
